import { useCurrency } from "@/contexts/CurrencyContext";
import { CURRENCY_LABEL, Currency } from "@/lib/pricing";

interface Props {
  className?: string;
  variant?: "light" | "dark";
}

/** Compact currency switcher. "light" = light text on dark backgrounds. */
export default function CurrencySelector({ className = "", variant = "dark" }: Props) {
  const { currency, setCurrency, currencies } = useCurrency();

  const base =
    variant === "light"
      ? "bg-transparent text-cream/80 hover:text-cream border-cream/25"
      : "bg-transparent text-ink/70 hover:text-ink border-ink/20";

  return (
    <label className={`inline-flex items-center ${className}`}>
      <span className="sr-only">Currency</span>
      <select
        aria-label="Currency"
        value={currency}
        onChange={(e) => setCurrency(e.target.value as Currency)}
        className={`appearance-none rounded-full border px-3 py-1.5 text-xs font-semibold tracking-[0.08em] uppercase cursor-pointer transition-colors focus:outline-none focus:ring-1 focus:ring-terracotta/50 ${base}`}
      >
        {currencies.map((c) => (
          <option key={c} value={c} className="text-ink">
            {CURRENCY_LABEL[c]}
          </option>
        ))}
      </select>
    </label>
  );
}
